import React from 'react';

import { ProviderType } from 'generated/graphql';
import { CurrencyCode } from 'utils/currencyFormat';

import { Transaction } from '../types';

import { GivingAccountFundingTransactionRow } from './GivingAccountFundingTransactionRow';
import { GivingAccountTransferInboundTransactionRow } from './GivingAccountTransferInboundTransactionRow';
import { GivingAccountTransferOutboundTransactionRow } from './GivingAccountTransferOutboundTransactionRow';
import { GivingAccountWithdrawalTransactionRow } from './GivingAccountWithdrawalTransactionRow';

export const TransactionRow = ({
  transaction,
  accountCurrency,
  accountProvider,
}: {
  transaction: Transaction;
  accountCurrency: CurrencyCode;
  accountProvider: ProviderType;
}) => {
  switch (transaction.__typename) {
    case 'GivingAccountFunding':
      return (
        <GivingAccountFundingTransactionRow
          transaction={transaction}
          accountCurrency={accountCurrency}
          accountProvider={accountProvider}
        />
      );

    case 'GivingAccountTransferInbound':
      return (
        <GivingAccountTransferInboundTransactionRow
          transaction={transaction}
          accountCurrency={accountCurrency}
        />
      );

    case 'GivingAccountTransferOutbound':
      return (
        <GivingAccountTransferOutboundTransactionRow
          transaction={transaction}
          accountCurrency={accountCurrency}
        />
      );

    case 'GivingAccountWithdrawal':
      return (
        <GivingAccountWithdrawalTransactionRow
          transaction={transaction}
          accountCurrency={accountCurrency}
          accountProvider={accountProvider}
        />
      );

    default:
      return null;
  }
};

export default TransactionRow;
